export default __webpack_public_path__ + "static/media/martin_fifa.aca6e020.png";